<template>
  <div class="distrustWrapper">
      <!-- 收到包裹 -->
      	<el-dialog
		  :title="$t('distrustOrder.bbvmkmg')"
		  size="mini"
		  :visible.sync="returnInfo"
		  width="60%"
		 >
		 <div style="margin-bottom: 15px;">
			 <el-upload
               ref="upload"
			   class="upload-demo"
			   action="https://erp.shopsbu.com/service/access/upload"
               :headers="importHeaders"
			   :on-remove="handleRemove"
			   :on-success="handlePreview"
			   list-type="picture">
			   <el-button size="small" type="primary">{{$t('distrustOrder.momf')}}</el-button>
			   <div slot="tip" class="el-upload__tip">{{$t('distrustOrder.gytnv')}}</div>
			 </el-upload>
		 </div>
		 <div>
			 <el-input
			   type="textarea"
			   :placeholder="$t('distrustOrder.okjnmv')"
			   v-model="textarea"
			   maxlength="120"
			   show-word-limit
			 >
			 </el-input>
		 </div>
		  <span slot="footer" class="dialog-footer">
		    <el-button @click="returnInfo = false">{{$t('distrustOrder.cancel')}}</el-button>
		    <el-button type="primary" @click="comfirm">{{$t('distrustOrder.confirmBtn')}}</el-button>
		  </span>
		</el-dialog>
        <!-- 查看包裹详情 -->
        <el-dialog
		  :title="$t('distrustOrder.okgnv')"
		  :visible.sync="returnbag"
		  width="70%"
		  >
          
		  <div class="returnbag-box">
			   <el-table
			        :data="viewReturnDescData.returnItems"
			        style="width: 100%"
                    border
					height="400px"
					>
			        <el-table-column
			          prop="date"
			          label="Img"
			         >
					  <template slot-scope="scope">
					  		<img v-image-preview :src="scope.row.image" alt="" style="width: 50px;height: 50px">
					  </template>
			        </el-table-column>
                    <el-table-column
					  :show-overflow-tooltip="true"
					  label="cusCode"
					 >
					  <template slot-scope="scope">
					  		<span>{{scope.row.storeItem.cusCode }}</span>
					  </template>
					</el-table-column>
			        <el-table-column
			          prop="itemName"
			          label="name"
					  :show-overflow-tooltip="true"
			          >
			        </el-table-column>
					<el-table-column
					  :show-overflow-tooltip="true"
					  label="sku"
					 >
					  <template slot-scope="scope">
					  		<span>{{scope.row.storeItem.skuName }}</span>
					  </template>
					</el-table-column>
			        <el-table-column
					  :show-overflow-tooltip="true"
			          label="methods">
					  <template slot-scope="scope">
					  		<span>{{auditType(scope.row.sellerReturnType)}}</span>
					  </template>
			        </el-table-column>
					<el-table-column
                   
					  prop="storeReturnNum"
					  :show-overflow-tooltip="true"
					  label="qty">
                      <template slot-scope="scope">
					  		<el-input-number  v-if="scope.row.storeReturnType == 2" size="mini" v-model="scope.row.storeReturnNum"  :min="0"  ></el-input-number>
					  </template>
					</el-table-column>
			      </el-table>
				  <div>
					  <el-input type="textarea" :placeholder="$t('distrustOrder.kvnkf')" v-model="textarea2" maxlength="120" show-word-limit >
                        </el-input>
				  </div>
			  
		  </div>
		    <div style="text-align: right;margin:10px 0">
				<el-button type="primary" @click="returnbag = false">{{$t('distrustOrder.cancel')}}</el-button>
                <el-button type="primary" @click="submit()">{{$t('distrustOrder.loknv')}}</el-button>
			</div>
		</el-dialog>

  
        
      <div style="font-size:25px;">{{$t('distrustOrder.returnMangement')}}</div>
      <div class="scan_Area">
          <div class="IdScaneArea">
			<el-input
			 size="mini"
			  v-model="scanNum"
			  :placeholder="$t('distrustOrder.scan')"
			  @change="packBageOut"
			  clearable>
			</el-input>
		</div>
      </div>
    <div class="filter_wrapper" v-show="index01 == 1"  v-for="(item,index01) in buttonList" :key="index01">
            <div >{{item.desc}}</div>
            <span class="filterbox" >
                <span class="storeBox"  :class="{'ttpactive':ttp.isActive  }"  :key="index"  v-for="(ttp,index) in item.value" @click="handleBtn(item,ttp.key,index,index01)">{{conversion(ttp.key,index01)}} <span v-show=" index01 !== 0">({{ttp.count}})</span></span>
            </span>
            <div class='jvnkf'>
                <el-input style="width:250px" clearable  size="medium" v-model="cusCode" :placeholder="$t('distrustOrder.orderSearch')"></el-input>
                <el-button size="medium" type="primary" @click="search()">{{$t('distrustOrder.serach')}}</el-button>
            </div>
    </div>

      <div class="no_data" v-if="!allOrderList.length">{{$t('distrustOrder.status')}}</div>
      <div v-else class="order_Area">
            <div class="order_item" v-for="(item,index) in allOrderList" :key="index">
                <div class="ordersn_no">
                    <span class="ordersn_no_item">{{$t('distrustOrder.orderId')}}:{{item.orderId}}</span>
                    <span class="ordersn_no_item">{{$t('distrustOrder.orderStatus')}}:{{item.orderStatus}}</span>
                    <span class="ordersn_no_item">{{$t('distrustOrder.createdTimed')}}:{{getTime(item.createTime)}}</span>
                    <span class="ordersn_no_item">{{$t('other.a799')}}:{{item.userId}}</span>
                </div>
                <div class="childrenItem_item" v-for="(childrenItem,indexOne) in item.returnItems" :key="indexOne">
                    <div class="item_box">
                        <div class="pic_box">  <img style="width:100%" :src="childrenItem.image" /></div>
                        <div>
                            <div class="item_desc_item">{{childrenItem.itemName}}</div>
                            <div class="item_desc_item">{{$t('distrustOrder.position')}}：{{childrenItem.storeItem ? childrenItem.storeItem.address ? childrenItem.storeItem.address :$t('other.a354') : $t('other.a354')}}</div>
                            <div class="item_desc_item">Qty：x{{childrenItem.variationQuantityPurchased}}</div>
                            <div  v-if="childrenItem.storeItem && childrenItem.storeItem.putAway && childrenItem.storeItem.children">
                                <span class="distribution_item">{{$t('other.a710')}}</span>
                                <span style="margin-left:20px">{{$t('other.a711')}}：{{childrenItem.storeItem.children[0].userId}}</span>
                            </div>
                        </div>
                        <div class="item_desc_item">
                            <div v-if="childrenItem.storeItem && childrenItem.platform !=='DXS'">
                                <span>{{$t('distrustOrder.cuscode')}}：{{childrenItem.storeItem.cusCode}} ( {{childrenItem.storeItem.component ? $t('other.a251') : $t('other.a252')}}) x{{childrenItem.variationQuantityPurchased}}</span>
                            </div>
                            <div v-if="childrenItem.storeItem && !childrenItem.storeItem.component && childrenItem.storeItem.children">
                                <div v-for="(ccp,indexCpp) in childrenItem.storeItem.children" :key="indexCpp">
                                    <a :title="ccp.skuName"><div class="skuname">{{$t('distrustOrder.originsku')}}：{{ccp.skuName}}</div></a>
                                    <div>{{$t('distrustOrder.oknlv')}}x{{ccp.rate*childrenItem.variationQuantityPurchased}}（{{ccp.cusCode}}）</div>
                                </div>
                            </div>
                            <div v-if="childrenItem.storeItem && childrenItem.storeItem.component">
                                <a :title="childrenItem.storeItem.skuName"><div class="skuname">{{$t('distrustOrder.originsku')}}：{{childrenItem.storeItem.skuName}}</div></a>
                                <div>{{$t('distrustOrder.purchaseNum')}}：x{{childrenItem.variationQuantityPurchased}}</div>
                            </div>

                            <!-- <div class="item_desc_item"><span class="knvf">{{$t('other.a659')}}:</span>{{childrenItem.storeItem ? childrenItem.storeItem.itemSku : '该产品未绑定仓库产品'}}</div>
                            <div class="item_desc_item"><span class="knvf">{{$t('other.a2139')}}:</span>{{childrenItem.storeItem ? childrenItem.storeItem.skuName : '该产品未绑定仓库产品'}}</div>
                            <div class="item_desc_item"><span class="knvf">{{$t('other.a226')}}</span>{{childrenItem.storeItem ? childrenItem.storeItem.cusCode : $t('other.a354')}}</div>
                            <div class="item_desc_item"><span class="knvf">{{$t('other.a633')}}:</span>x{{childrenItem.variationQuantityPurchased ? childrenItem.variationQuantityPurchased : $t('other.a354')}}</div> -->
                        </div>
                        <div>
                            <div style="margin-bottom:5px;color:rgb(245, 34, 45)" v-show="options.orderType !== 1">{{$t('distrustOrder.inlnv')}}
                                <span>{{auditType(childrenItem.sellerReturnType)}}</span>
                            </div>
                            <div style="margin-bottom:5px;color:rgb(245, 34, 45)" v-show="options.orderType !== 1 && childrenItem.sellerReturnType == 2">{{$t('distrustOrder.konmkf')}}
                                <span >{{childrenItem.sellerReturnNum}}</span>
                            </div>
                            <div v-if="item.returnType == 3" style="margin-bottom:5px;color:rgb(42, 165, 21)" v-show="options.orderType !== 1">{{$t('distrustOrder.lkndv')}}
                                <span>{{auditType(childrenItem.storeReturnType)}}</span>
                            </div>
                             <div v-if="item.returnType == 3" style="margin-bottom:5px;color:rgb(42, 165, 21)" v-show="options.orderType !== 1 && childrenItem.sellerReturnType == 2">{{$t('distrustOrder.konmkf')}}
                                <span >{{childrenItem.storeReturnNum}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="btn_box">
                        <div ><el-button v-if="item.returnType==null && indexOne ==0 " class="btn" type="primary" @click="receiveBag(item)">{{$t('distrustOrder.knvtr')}}</el-button></div>
                        <div ><el-button v-if="item.returnType==1 && indexOne ==0" class="btn" type="primary" @click="waitSeller()">{{$t('distrustOrder.knvfvtr')}}</el-button></div>
                        <div ><el-button v-if="item.returnType==2 && indexOne ==0" class="btn" type="danger" @click="viewMore(item)">{{$t('distrustOrder.pkjnmg')}}</el-button></div>
                        <div ><el-button v-if="item.returnType==1 && indexOne ==0" class="btn" type="danger" @click="deleteItem(item,index)">{{$t('other.a312')}}</el-button></div>
                        <!-- <div ><el-button v-if="item.returnType==3 && indexOne ==0" class="btn" type="danger" >退货处理完成</el-button></div> -->
                        <!-- <div  v-if="item.returnType==2 && isDistributeStore(item) && indexOne ==0"><el-button type="primary" @click="printCode(item)">重新打印条形码</el-button></div> -->
                          
                    </div>
                </div>
                <div class="item_desc" v-if="item.returnType ==2 || item.returnType == 3">{{$t('distrustOrder.bbnkf')}}{{item.receivedMsg ? item.receivedMsg : $t('other.a354')}}</div>
                <div class="item_desc" v-if="item.returnType ==2 || item.returnType == 3">{{$t('distrustOrder.pombkg')}}{{item.sellerMsg ? item.sellerMsg : $t('other.a354')}}</div>
                
            </div>
        
                        
            <div v-if="allOrderList.length" class="Pager">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="currentPage"
                    :page-sizes="[15, 20, 30, 50]"
                    :page-size="options.offset"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="orderCount">
                </el-pagination>
            </div>
      </div>
  </div>
</template>

<script>
import orderApi from '../../../api/moudles/order'
import utils from '../../../utils/utils'
import newOrders from '../../../api/moudles/newOrders'
import {mapState, mapActions , mapMutations} from 'vuex'
export default {
data(){
return{
    scanNum:'',
    active:-1,
    allOrderList:[],
    storeId:null,
    textarea:'',
    returnInfo:false,
    viewReturnDescData:'',
    cusCode:null,
    allstore:[],
    fileList:[],
    returnbag:false,
    returnImag:'',
    orderlist:[],
    openDistributeDia:false,
    currentPage:1,
    userId:JSON.parse(localStorage.getItem('userInfo')).userId,
    importHeaders: {token: JSON.parse(localStorage.getItem('userInfo')).token},
    orderCount:0,
    textarea2:'',
    getDataParams:{
        end:null,
        start:null,
        offset:15,
        
        orderType:null,
        orderId:'',
        hasPdf:true,
        hasStoreItem:true,
        page:0,
        platform:null,
        shopIds:JSON.parse(localStorage.getItem('userInfo')).shopIds,
        sortType:null,
        storeIds:JSON.parse(localStorage.getItem('userInfo')).storeIds,
        userId:JSON.parse(localStorage.getItem('userInfo')).userId,
    },
    buttonList:[{
        isActive:0,
        desc:this.$t('distrustOrder.status'),
        value:[{
            isActive:true,
            key:1,
            count:0,
        },{
            key:2,
            isActive:false,
            count:0,
        },{
            key:3,
            isActive:false,
            count:0,
        }]
    }],
    options:{
        offset: 50,
        page: 0,
        shopIds: [],
        orderId:null,
        isHidden:0,
        orderType:1,
        sortType: 2,
        platform: null,
        hasPdf:true,
        start:null,
        end:null,
        storeIds:[],
        userId: JSON.parse(localStorage.getItem('userInfo')).userId,
    },
    distributeItems:[]
}
},
watch:{
    returnInfo(){
        if(!this.returnInfo){
            this.fileList=[]
            this.$refs.upload.clearFiles()
            this.textarea=''
            this.storeId=null
        }
    },

    cusCode(){
        if(!this.cusCode){
            this.options.orderId=null
            this.getOrderData(this.options)
        }
    }
},
created(){
   this.init()
   this.getOrderData(this.options)
},

methods:{

    ...mapActions('order', [
        'queryReturnOrderNum',
    ]),


    isDistributeStore(item){
        
        let obj=false
        item.returnItems.forEach(p => {
            if(utils.isDistributionStroe(p.storeItem.storeId)) {
                obj=true 
            }
        })
        return  obj
    },        

    submit(){
       

        let params={
            orderId:this.viewReturnDescData.orderId,
            platform:this.viewReturnDescData.platform,
            receivedMsg:this.textarea2,
            sellerMsg:this.viewReturnDescData.sellerMsg,
            returnItems:this.viewReturnDescData.returnItems,
            shopId:this.viewReturnDescData.shopId,
            storeId:this.viewReturnDescData.storeId,
            userId:JSON.parse(localStorage.getItem('userInfo')).userId
        }

        console.log('params',params)
        orderApi
        .storeComfirm(params)
        .then(res => {
            if(res.code === 200) {
                this.$message.success(this.$t('other.a719'))
                localStorage.removeItem('reprintedOrder')
                this.returnbag=false
                this.getOrderData(this.options)
            }else{
                this.$message.warning(res.msg)
            }
        })
       
    },

    deleteItem(item,index){
        console.log(item)
        this.$confirm(this.$t('other.a608'), this.$t("other.a142"), {
        confirmButtonText: this.$t('other.a235'),
        cancelButtonText: this.$t('other.a146'),
        type: 'warning'
        }).then(() => {
            newOrders
            .alertReturnOrders({
                isHidden:1,
                isSelectAll:false,
                orderIds:[item.orderId],
                orderType:1,
                userId:this.userId,
            })
            .then(res => {
            if(res.code === 200 ){
            console.log('desc',res.data)
            this.$message.success(this.$t('other.a800'))
            this.getOrderData(this.options)
            this.orderlist.splice(index,1)
            }else{
            this.$message.warning(res.msg)
            }
            })
        })
    },

    comfirm(){
        let params={
            receivedMsg:this.textarea,
            returnOrderImages:this.fileList,
            sellerMsg:'',
            orderId:this.targerItem.orderId,
            platform:this.targerItem.platform,
            userId:this.getDataParams.userId,
            shopId:this.targerItem.shopId,
            storeId:this.targerItem.storeId,
        }
        console.log(params)
        orderApi
        .receiveReturn(params)
        .then(res => {
            if(res.code === 200) {
                this.$message.success(this.$t('other.a801'))
                this.allOrderList.forEach(p => {
                    if(p.orderId === params.orderId){
                        p.returnType=1
                    }
                })
               this.returnInfo=false
            }else{
                this.$message.error(res.msg)
            }
        })


        
 
        
    },
    waitSeller(){
        this.$message.warning(this.$t('other.a802'))
    },
    handleBtn(item,value,index01,index){
				console.log(item,value,index01,index)
				this.buttonList[index].value.forEach(p => {
					p.isActive=false
				})
				this.buttonList[index].value[index01].isActive=true
				
				if(index == 0){
					this.options.shopIds=value ? [value] : JSON.parse(localStorage.getItem('userInfo')).shopIds
				}
				if(index == 1){
					this.options.orderType=value
				}

				console.log(this.options)
				this.getOrderData(this.options)
			
				
			
	},

    init(){
        this.allstore=JSON.parse(localStorage.getItem('userInfo')).stores.map(p => {
            return {
                label:p.storeName,
                value:p.storeId
            }
        })
        JSON.parse(localStorage.getItem('userInfo')).sellers.forEach(p => {
            if(p.shopIds){

                p.shopIds.forEach(k => {
                    this.options.shopIds.push(k)
                })
            }
        })
        this.options.storeIds=JSON.parse(localStorage.getItem('userInfo')).storeIds
        this.buttonList.unshift({
            isActive:0,
            desc:this.$t('other.a803'),
            value:JSON.parse(localStorage.getItem('userInfo')).sellers.map(p => {
                return {
                    key:p.userId,
                    isActive:false,
                    count:0
                }
            })
        })

        this.buttonList[0].value.unshift({
            isActive:true,
            key:"",
            count:0
        })

        
    },

    conversion(value,index){
        if(index == 0 ){
            if(value == '') {
                return this.$t('other.a358')
            }
            return value
        }else if(index == 1) {
            let obj={
                1:this.$t('distrustOrder.sellerConfirm'),
                2:this.$t('distrustOrder.hasConfirm'),
                3:this.$t('distrustOrder.aleadyAudit'),
            }
            return obj[value]
        }
    },

    search(){
        this.options.orderId=this.cusCode
        this.getOrderData(this.options)
    },

    searchLogistics(item) {
        console.log('item',item)
        orderApi
        .viewLogistics(item) 
		.then(res => {
			if(res.code === 200) {
				console.log('物流信息',res.data)
				
			}
		})
   
    },
    handleSizeChange(val) {
        this.options.offset=Number(`${val}`)
        this.getOrderData(this.options)
        },
    handleCurrentChange(val) {
        
        this.options.page=this.options.offset*(Number(`${val}`) -1)
        console.log(this.options)
        this.getOrderData(this.options)
    },

    getOrderData(payload){
        orderApi
        .queryReturnOrder(payload)
        .then(res => {
            if(res.code === 200) {	
                console.log("退货订单",res.data)
                this.allOrderList=res.data.orders
                this.orderCount=res.data.count
                res.data.otherCount.forEach(p => {
                    this.buttonList[1].value.forEach(k => {
                        if(p.type == k.key){
                            k.count=p.count
                        }
                    })
                })
                console.log(this.buttonList)
            }
        })	
    },

    receiveBag(item){
        this.returnInfo=true
        this.targerItem=item
        console.log(item)
    },
    packBageOut(){
        console.log(this.scanNum)
        console.log(this.getDataParams)
        this.getDataParams.orderId=this.scanNum
        if(this.getDataParams.orderId){
            orderApi
            .getDistrustOrders(this.getDataParams)
            .then(res => {
                if(res.code === 200) {
                     this.scanNum=''
                    console.log('获取订单信息',res.data)
                    res.data.orders.forEach(p => {
                        let flag=false
						p.returnItems=p.returnItems ? p.returnItems : p.items
                        flag=this.allOrderList.some(k => k.orderId == p.orderId)
                        if(flag){
                            this.$message.warning(this.$t('other.a804'))
                            return
                        }
                        this.allOrderList.unshift(p)
                    })

                    console.log('allOrderList',this.allOrderList)
                   
                    
                }
            })
        }
        
        
    },
    handleRemove(file, fileList) {
    
    console.log(file, fileList);
    },
    handlePreview(file) {
    console.log(file);
    this.fileList.push(	{
        imageUrl:file.data
    })
    },
    getStatus(item){
        let ttp=utils.conversionStatus(item)
        return ttp
    },
    getTime(item){
        return utils.renderTime(item)
    },
    ttp01(num){
        if(this.active == num) {
            this.active=-1
        }else{
            this.active=num
            
        }
    },
    //重新打印分销商品的条形
    printCode(){
       
        let storeItemList=this.distributeItems
        
        

        let list=storeItemList.map(p => {
            return {
                address:p.storeItem.address,
                itemSku:p.storeItem.skuName,
                items:{
                    content:p.storeItem.cusCode,
                    height:80,
                    width:320,
                },
                num:p.variationQuantityPurchased,
                parentSku:p.storeItem.itemSku,
                variationName:p.storeItem.skuName,
                userId:p.storeItem.userId,
                storeId:p.storeItem.storeId
            }
        })

        utils.settUserAtt({
            attribute:JSON.stringify({
                data:JSON.stringify(list),
              
            }),
            userId:this.userId
        })

        let routeData = this.$router.resolve({
            name: "barCode",
           
        })
        
        window.open(routeData.href, '_blank')
        console.log(storeItemList)
        console.log(list)

    },
    viewMore(item){
        console.log(item)
        if(item.returnItems){
            item.returnItems.forEach(p =>  {
                if(p.sellerReturnType == 2){//重新上架的sku
                    p.storeReturnType=p.sellerReturnType
                    p.storeReturnNum=p.sellerReturnNum
                }else{
                    p.storeReturnType=p.sellerReturnType
                    p.storeReturnNum=0
                }
            })

            this.viewReturnDescData=item
            this.returnbag=true
        }
		// console.log(item)
        // let storeItemList=[]
        // if(item.returnItems){
        //     item.returnItems.forEach(p =>  {
        //         if(utils.isDistributionStroe(p.storeItem.storeId)){
        //             storeItemList.push(p)
        //         }
        //     })
        // }

        // if(storeItemList.length > 0){
        //     let reprintedOrder= localStorage.getItem('reprintedOrder')
        //     if(reprintedOrder){
        //      console.log(storeItemList)
        //         item.returnItems.forEach(p => {
        //             p.storeReturnType=p.sellerReturnType
        //             p.storeReturnNum=p.sellerReturnNum
        //         })
        //         item.storeReturnType=item.sellerReturnType
        //         this.viewReturnDescData=item
        //         this.returnbag=true
        //         this.returnImag=item.returnOrderImages
        //         console.log('退货详情',this.viewReturnDescData)

        //     }else{

        //         this.distributeItems=storeItemList
        //         this.openDistributeDia=true
        //     }
           
        // }else{
        //     console.log(storeItemList)
        //     item.returnItems.forEach(p => {
        //         p.storeReturnType=p.sellerReturnType
        //         p.storeReturnNum=p.sellerReturnNum
        //     })
        //     item.storeReturnType=item.sellerReturnType
        //     this.viewReturnDescData=item
        //     this.returnbag=true
        //     this.returnImag=item.returnOrderImages
        //     console.log('退货详情',this.viewReturnDescData)
        //     }

       

        
    },
    auditType(num){
        const ttp={
            0:this.$t("other.a140"),
            1:this.$t('other.a805'),
            2:this.$t('other.a806'),
            3:this.$t('other.a807')
        }
       
        return ttp[num]
    },

}
}

</script>
<style lang="scss" scoped>
@import "~@assets/scss/mixins";


.distrustWrapper{
    // @include main-right-content();
    padding-right: 10px;

    /deep/.IdScaneArea .el-input__inner{
        width: 99%;
        height: 80px;
        font-size: 30px
	}

    .distribution_item{
            color: #fff;
            font-weight: 550;
            display: inline-block;
            background-color: #67c23a;
            text-align: center;
            border-radius: 8px;
            margin: 5px 0;
            box-sizing: border-box;
            padding: 2px 10px;
    }

    .jvnkf{
        display: flex;
    }

     .item_desc{
        padding: 2px 10px;
        color: red;
        
    }

    .Pager{
		position: fixed;
		bottom: 0;
		left: 200px;
		right: 0;
		height: 40px;
		line-height: 40px;
		background-color: #fff;
		text-align:right;
	}

    .filter_wrapper{
        margin: 20px 0;
        display: flex;
        align-items: center;
    }

    .filterbox{
        display: flex;
	    flex-wrap: wrap;
		flex: 1;



        .storeBox{
            border: 1px solid #eee;
            box-sizing: border-box;
            padding: 6px 15px ;
            font-size: 14px;
            cursor: pointer;
            margin:2px 2px;
        }

        .ttpactive{
            background-color: #1890ff;
            color: #fff;
        }

        .ttpactive:hover{
            background-color: #40a9ff;
            color: #fff;
        }
    }

    .scan_Area{
        margin: 10px 0;
    }


    .no_data{
        text-align: center;
        margin-top: 200px;
        font-size: 18px;
        color: #909399;
    }

    .order_Area{
        margin-bottom: 60px;
        .order_item{
            border: 1px solid #eee;
            margin-bottom: 10px;

            .ordersn_no{
                padding: 6px 0;
                border-bottom: 1px solid #eee;
                background-color: #eee;

                .ordersn_no_item{
                    margin: 0 10px;
                }

            }
        }

        .childrenItem_item{
            @include flex-between();
            border-bottom: 1px solid #eee;
            .item_box{
                display: flex;
            }
            .btn_box{
                margin-right: 15px;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;

               .btn{
                   width: 150px;
                   padding:10px;
                   margin: 5px 0;
               }
            }
        
            .pic_box{
                width: 80px;
                height: 80px;
            }

            .item_desc_item{
                width: 400px;
                box-sizing: border-box;
                padding: 2px 10px;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
               

                .knvf{
                    display: inline-block;
                    width: 90px;
                    text-align: right;
                    padding-right: 10px;
                }
            }

           
        }
    }


}
</style>